module.exports = __webpack_public_path__ + "img/bao_fyldt2.14abca1e.jpg";